import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import ShortText from './ShortText'
import DatePickers from './DatePicker'
import Phone from './Phone'
import Email from './Email'
import MultiChoice from './MultiChoice'
import LongText from './LongText'
import Number from './Number'

const FarmerCooperativeCheckInForm = () => {


    const produceBroughtData =[
        {
            id: 1,
            label: 'سبزیجات',
            checked: false
        },
        {
            id: 2,
            label: 'میوه‌ها',
            checked: false
        },
        {
            id: 3,
            label: 'غلات',
            checked: false
        },
        {
            id: 4,
            label: 'لبنیات',
            checked: false
        },
        {
            id: 5,
            label: 'دام',
            checked: false
        },
        {
            id: 6,
            label: 'دیگر',
            checked: false
        },

    ]

    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم ثبت نام تعاونی کشاورزان'} subHeader={'لطفا برای ثبت نام در شرکت تعاونی کشاورزان، این فرم را پر کنید.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'}/>
                <ShortText header={'نام مزرعه'}/>
                <DatePickers header={'تاریخ ورود'}/>
                <Phone header={'شماره تلفن'}/>
                <Email header={'آدرس ایمیل'}/>
                <MultiChoice header={'نوع محصول آورده شده'} options={produceBroughtData}/>
                <Number header={'مقدار محصول (به کیلوگرم یا واحد)'}/>
                <LongText header={'نظرات اضافی'}/>
            </Grid>
        </Grid>
    )
}

export default FarmerCooperativeCheckInForm
